import { Link, useLocation } from 'react-router';
import { useCallback } from 'react';
import { NAV_PATH, ROUTER_PATH } from '@/router/constants';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { UiCommon } from '@/common/common';

const images = {
	bnr_mim: require('@/assets/images/common/img_header_banner_mim.png'),
	bnr_draft: require('@/assets/images/common/img_header_banner_draft.png'),
	bnr_car: require('@/assets/images/common/img_header_banner_car.png'),
	bnr_debt: require('@/assets/images/common/img_header_banner_debt.png'),
	bnr_pro: require('@/assets/images/common/img_header_banner_pro.png'),
	bnr_bookmark: require('@/assets/images/common/img_header_banner_bookmark.png')
};
const banner = [
	{
		src: images.bnr_mim,
		link: `${NAV_PATH.FUNCTION.CONVENIENCE}#${'mim'}`,
		alt: '[공지] 모바일 재고관리 앱 ‘밈(MIM)’ 출시 !'
	},
	{
		src: images.bnr_draft,
		link: `${NAV_PATH.FUNCTION.MAIN}#${'accountancy'}`,
		alt: '[기능추가] 어음관리 – 어음을 간편하게 관리하세요.'
	},
	{
		src: images.bnr_car,
		link: `${NAV_PATH.FUNCTION.MAIN}#${'basis'}`,
		alt: '[기능추가] 업무용승용차 – 차량 운행과 비용을 한번에 관리!'
	},
	{
		src: images.bnr_bookmark,
		link: `${NAV_PATH.FUNCTION.CONVENIENCE}#${'bookmark'}`,
		alt: '[업데이트] 자주 쓰는 기능을 한눈에! 마이메뉴 기능 추가!'
	},
	{
		src: images.bnr_debt,
		link: `${NAV_PATH.FUNCTION.CONVENIENCE}#${'offsetmanagement'}`,
		alt: '[주요공지] 매출채권/매입채무 관리를 위한 반제관리 기능 추가!'
	},
	{
		src: images.bnr_pro,
		link: `${NAV_PATH.CONSULTING}`,
		alt: '[주요공지] 국내 최고 전문가팀과 함께하는 전문가문의 기능 추가'
	}
];

const HeaderGroup = () => {
	// Active 클래스 추가 로직
	const { pathname } = useLocation();
	const isActive = useCallback(
		(path: string | string[]) => {
			if (typeof path === 'string') {
				if (pathname.includes(path)) {
					return 'active';
				} else {
					return '';
				}
			} else {
				const isActive = path.some(p => pathname.includes(p));
				return isActive ? 'active' : '';
			}
		},
		[pathname]
	);

	return (
		<>
			<div className="header-banner">
				<Swiper
					direction="vertical"
					slidesPerView={1}
					loop
					autoplay={{
						delay: 5000,
						speed: 5000
					}}
					modules={[Autoplay]}>
					{banner.map((slide, index) => (
						<SwiperSlide key={index}>
							<a href={slide.link}>
								<img src={slide.src} alt={slide.alt} />
							</a>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
			<div className="header-group">
				<div className="header-inner">
					<h1 className="logo-wrap">
						<Link className="logo" to="/" title="Stella logo" aria-hidden="true">
							<span className="blind">홈으로</span>
						</Link>
					</h1>
					<nav id="" className="gnb-wrap">
						<ul className="gnb">
							<li className={`depth1 ${isActive(NAV_PATH.INTRO)}`}>
								<Link to={NAV_PATH.INTRO}>서비스 소개</Link>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.FUNCTION))}`}>
								<Link to={NAV_PATH.FUNCTION.MAIN} className="new">
									특별한 기능
								</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.FUNCTION.MAIN)}`}>
										<Link to={NAV_PATH.FUNCTION.MAIN}>주요 기능</Link>
									</li>
									<li className={`depth2 ${isActive(NAV_PATH.FUNCTION.CONVENIENCE)}`}>
										<Link to={NAV_PATH.FUNCTION.CONVENIENCE}>편의 기능</Link>
									</li>
								</ul>
							</li>
							<li className={`depth1 ${isActive(NAV_PATH.PRICE)}`}>
								<Link to={NAV_PATH.PRICE}>가격 정책</Link>
							</li>
							<li className={`depth1 ${isActive(NAV_PATH.CONSULTING)}`}>
								<Link to={NAV_PATH.CONSULTING}>전문가문의</Link>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.CUSTOMER_SUPPORT))}`}>
								<Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ}>고객 지원</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.CUSTOMER_SUPPORT.NOTICE)}`}>
										<Link to={NAV_PATH.CUSTOMER_SUPPORT.NOTICE}>공지사항</Link>
									</li>
									<li className={`depth2 ${isActive(NAV_PATH.CUSTOMER_SUPPORT.FAQ)}`}>
										<Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ}>자주 묻는 질문</Link>
									</li>
									{/* <li className={`depth2 ${isActive(NAV_PATH.CUSTOMER_SUPPORT.EVENT)}`}>
									<Link to={NAV_PATH.CUSTOMER_SUPPORT.EVENT}>이벤트</Link>
								</li> */}
								</ul>
							</li>
							<li className={`depth1 ${isActive(Object.values(ROUTER_PATH.INQUIRY))}`}>
								<Link to={NAV_PATH.INQUIRY.SERVICE}>문의하기</Link>
								<ul>
									<li className={`depth2 ${isActive(NAV_PATH.INQUIRY.SERVICE)}`}>
										<Link to={NAV_PATH.INQUIRY.SERVICE}>서비스 문의</Link>
									</li>
									<li className={`depth2 ${isActive(NAV_PATH.INQUIRY.PARTNERSHIP)}`}>
										<Link to={NAV_PATH.INQUIRY.PARTNERSHIP}>제휴 문의</Link>
									</li>
								</ul>
							</li>
						</ul>
					</nav>

					<div className="button-group">
						<a
							className="btn primary round md"
							rel="noopener noreferrer"
							target="_blank"
							title="새창 열림"
							onClick={() => UiCommon.goStellaService('/views/US/01/US-01-220.html')}>
							2개월 무료체험하기
						</a>
						<a
							className="btn primary round border md"
							rel="noopener noreferrer"
							target="_blank"
							title="새창 열림"
							onClick={() => UiCommon.goStellaService()}>
							스텔라 로그인
						</a>
					</div>
				</div>
			</div>
		</>
	);
};

export default HeaderGroup;
